<script>
import moment from 'moment'

export default {
  name: 'PreviousDiff',
  props: {
    previousObject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      disableDiff: false,
    }
  },
  methods: {
    diffAttributes(previous, current, options = null) {
      const hasDiff = this.hasDiff(previous, current)
      return {
        class: { edited: hasDiff },
        hint: hasDiff
          ? `変更前: ${options ? options[previous] : (previous || '')}`
          : '',
        'persistent-hint': true,
      }
    },
    hasDiff(previous, current) {
      if (this.$store.getters.hasPendingAjax || this.disableDiff) {
        return false
      }
      if (previous === undefined) {
        return false
      }
      const asArray = Array.isArray(current)
      if (asArray) {
        if (window._.isEqual(previous, current)
          || window._.isEqual(previous.map(f => f.id).sort(), current.map(f => f).sort())) {
          return false
        }
        return true
      }
      return !window._.isEqual(previous, current)
    },
    previousValue(previous, current, options = null) {
      return this.hasDiff(previous, current)
        ? `変更前: ${options ? options[previous] : (previous ?? '')}`
        : ''
    },
    previousDate(previous, current) {
      if (!previous) return '変更前:'
      return this.hasDiff(previous, current)
        ? `変更前: ${moment(previous).format('Y-MM-DD')}`
        : ''
    },
  },
}
</script>
